import { render, staticRenderFns } from "./dish-filter.vue?vue&type=template&id=bd9d1aae&"
import script from "./dish-filter.vue?vue&type=script&lang=js&"
export * from "./dish-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports